import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import './AccountMenuContext.scss'; 
import { useNavigate } from 'react-router-dom';

const AccountMenuContext = ({ onClose, onLogout, username }) => {
  const navigate = useNavigate();

  const handleMyOrders = () => {
    //navigate('/orders');
    onClose();
  };

  const handleMyFavourites = () => {
    navigate('/favourites');
    onClose();
  };

  return (
    <div className="account-menu-context">
      <div className="account-menu-header">
      <button className="close-btn" onClick={onClose}>
          <FontAwesomeIcon icon={faTimes} />
        </button>
        <div className="username">{username}</div>
      
      </div>
      <div className="account-menu-items">
        <div className="menu-item" onClick={handleMyOrders}>
          My Orders
        </div>
        <div className="menu-item" onClick={handleMyFavourites}>
          Favourites
        </div>
        <div className="menu-item" onClick={onLogout}>
          Logout
        </div>
      </div>
    </div>
  );
};

export default AccountMenuContext;